import { t } from "@/i18n";
import { CountUp, Spotlight, Sparkline } from "./motion";

export const StatCard = ({ icon: Icon, label, value, sub, testId, accent, spark, sparkColor, progress }) => (
  <Spotlight className="p-6 group" data-testid={testId}>
    <div className="flex items-start justify-between">
      <p className="eyebrow">{label}</p>
      <span className={`h-9 w-9 rounded-xl grid place-items-center transition-transform duration-300 group-hover:scale-110 group-hover:rotate-6 ${accent ? "bg-primary/10 text-primary ring-1 ring-primary/30" : "bg-muted text-muted-foreground"}`}>
        <Icon className="h-4 w-4" />
      </span>
    </div>
    <p className="font-display text-4xl font-extrabold mt-3 tracking-tight"><CountUp value={value} /></p>
    {sub && <p className="text-xs text-muted-foreground mt-1">{sub}</p>}
    {spark && <div className="mt-3 -mb-1"><Sparkline data={spark} color={sparkColor} /></div>}
    {typeof progress === "number" && (
      <div className="mt-3 h-1.5 rounded-full bg-muted overflow-hidden" title={`${progress}%`}>
        <div className="h-full rounded-full bg-primary progress-fill" style={{ "--w": `${progress}%` }} />
      </div>
    )}
    {typeof progress === "number" && <p className="text-[10px] text-muted-foreground mt-1 text-right tabular-nums">{progress}% {t("completado")}</p>}
  </Spotlight>
);
